import React, { useState } from "react";
import PropTypes, { number } from "prop-types";
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import 'react-app-polyfill/ie11';
import Error from "./Error";

const Step2 = (props) => {
  const [hasTelInputError, setHasTelInputError] = useState(false);
  const [telInputErrorMessage, setTelInputErrorMessage] = useState('');
  const [hasAssocInputError, setHasAssocInputError] = useState(false);
  const [assocInputErrorMessage, setAssocInputErrorMessage] = useState('');
  const [hasBirthDateInputError, setHasBirthDateInputError] = useState(false);
  const [birthDateInputErrorMessage, setBirthDateInputErrorMessage] = useState('');
  const [member, setMember] = useState(props.defaultMember);


  /**
   * 0-現在の年までの配列を作成し、1900以上を取得する
   * [1900, 1901, 1902, ..., (new Date).getFullYear()]
   */
  const yearList = [...Array((new Date).getFullYear() + 1).keys()].filter(year => 1900 <= year).reverse();




  const onClickNextPage = () => {
    if (member.telephone_number_1 != null && member.telephone_number_2 != null && member.telephone_number_3 != null) {
      member.telephone_number = member.telephone_number_1 + '-' + member.telephone_number_2 + '-' + member.telephone_number_3;
    }
    if (member.birth_date_year != null && member.birth_date_month != null && member.birth_date_date != null) {
      member.birth_date = member.birth_date_year + '/' + member.birth_date_month + '/' + member.birth_date_date;
    }

    fetch(props.validate_step2_url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': props.csrf_token
      },
      body: JSON.stringify({ member: member })
    }).then((res) => {
      return res.json();
    }).then((data) => {
      setHasTelInputError(false);
      setHasAssocInputError(false);
      setHasBirthDateInputError(false);
      if (data.status === 200) {
        props.slickGoTo(2);
      } else if (data.status === 400) {
        data.errors.forEach(errorParam => {
          if (errorParam.value === 'association_id') {
            setAssocInputErrorMessage(errorParam.reason);
            setHasAssocInputError(true);
          }

          if (errorParam.value === 'birth_date') {
            setBirthDateInputErrorMessage(errorParam.reason);
            setHasBirthDateInputError(true);
          }
        });
      }
    }).catch((err) => {
      console.error(err);
    });
  };

  return (
    <div className="page_step2">
      <div className="input_area">
        <p>
          所属組合と<br className="sp" />組合員ご本人の生年月日を<br className="sp" />入力してください。
        </p>
        <div className="input_group_area">
          <table>
            <tbody>
              <tr>
                <th>所属組合</th>
                <td>
                  <Error message={assocInputErrorMessage} hasError={hasAssocInputError} />
                  <select tabIndex="3" id="form_index_3" defaultValue={member.association_id} onChange={e => setMember({ ...member, association_id: e.target.value })}>
                    <option value="">選択してください</option>
                    {
                      props.associations_list.map((name, i) =>
                        <option value={props.associations_list[i].id}>{props.associations_list[i].name}</option>)
                    }
                  </select>
                </td>
              </tr>
              <tr>
                <th>生年月日</th>
                <td>
                  <Error message={birthDateInputErrorMessage} hasError={hasBirthDateInputError} />
                  <select tabIndex="4" id="form_index_4" defaultValue={member.birth_date_year} className="birth_day_y"
                    onChange={e => setMember({ ...member, birth_date_year: e.target.value })}>
                    <option value="">選択してください</option>
                    {
                      yearList.map((year, i) =>
                        <option key={i} value={year}>{year}</option>)
                    }
                  </select>
                &nbsp;年<br className="sp" />
                  <div className="sp birthday_spacer" />
                  <input type="text" tabIndex="5" id="form_index_5" defaultValue={member.birth_date_month} className="birth_day"
                    placeholder="1" maxLength="2" style={{ width: "3em" }}
                    onChange={e => setMember({ ...member, birth_date_month: e.target.value })} />
                &nbsp;月&nbsp;
                <input type="text" tabIndex="6" id="form_index_6" defaultValue={member.birth_date_date} className="birth_day"
                    placeholder="1" maxLength="2" style={{ width: "3em" }}
                    onChange={e => setMember({ ...member, birth_date_date: e.target.value })} />
                &nbsp;日&nbsp;
                <p className="notice">※半角数字</p>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div className="input_group_area">
        <ul className="footer_button_area">
          <li><a className="btn_entry next_page" tabIndex="7" id="form_index_7" onClick={onClickNextPage}> 入力内容を確認する </a></li>
        </ul>
      </div>
    </div>
  )
};

Step2.propTypes = {
  defaultMember: PropTypes.object,
  associations_list: PropTypes.array,
  validate_step2_url: PropTypes.string,
  slickGoTo: PropTypes.func,
  csrf_token: PropTypes.string,
};

export default Step2;